<script setup lang="ts">
import type { SeminarCategory } from '~/gql/graphql';
import PillShapedSpan from '~theme/components/atoms/PillShapedSpan.vue';

defineProps<{ heading: string; seminarCategories: SeminarCategory[] }>();
const { toLabel } = useSeminarCategories();
</script>

<template>
  <div :class="$style.container">
    <h1 :class="$style.container__heading">{{ heading }}</h1>
    <ul :class="$style.container__categories">
      <li v-for="c in seminarCategories" :key="c">
        <PillShapedSpan :class="$style.container__category">{{
          toLabel(c)
        }}</PillShapedSpan>
      </li>
    </ul>
  </div>
</template>

<style module lang="scss">
.container {
  display: flex;
  gap: 16px;
  flex-direction: column;
  align-items: flex-start;

  &__heading {
    line-height: 1.8;
    font-size: 36px;
    font-weight: bold;

    @include mobile-only {
      font-size: 20px;
    }
  }

  &__categories {
    display: flex;
    gap: 4px;
    flex-wrap: wrap;
  }

  &__category {
    padding: 4px 12px;
    background-color: $color-surface-secondary;
    border: 2px solid $color-border-low-emphasis;
  }
}
</style>
